import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Button,
  Card,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { manageQuickAccessApi } from "../../store/quick-access/manageQuickAccess";
import { deleteQuickAccessApi } from "../../store/quick-access/deleteQuickAccess";

export default function DeleteQuickAccess({ open, setOpen, id, query, itemKey }) {
  const deleteQuickAccessState = useSelector((state) => state?.deleteQuickAccess);

  const dispatch = useDispatch();

  const handleClose = () => setOpen(false);

  const deleteConfirm = async () => {
    await dispatch(deleteQuickAccessApi(id));
    setOpen(false);
    if (!deleteQuickAccessState?.loading) {
      dispatch(manageQuickAccessApi(query));
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ width: "30%" }}>
          <Stack alignItems="flex-end">
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
          </Stack>
          <Stack alignItems="center" my={2}>
            <Typography variant="h5" fontWeight={600} textAlign="center">
              Are you sure you want to delete '{itemKey}'?
            </Typography>
            <Typography variant="h5" fontWeight={600} mt={1}>
              Please click confirm
            </Typography>
          </Stack>

          <Stack sx={{ mt: 2 }} justifyContent="center" direction="row">
            <Button variant="outlined" onClick={() => setOpen(false)} sx={{ mr: 2 }}>
              Back
            </Button>
            <Stack direction="row" spacing={1}>
              <Button variant="contained" onClick={deleteConfirm}>
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}

DeleteQuickAccess.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  id: PropTypes.any,
  query: PropTypes.any,
  itemKey: PropTypes.any
};
